export default function (element, action) {
    let device = '';
    if(window.innerWidth < 640){
        device = 'Mobile: ';
    } else {
        device = 'Desktop: ';
    }

    let event = 'Track Element ' + device + element;
    if(typeof _paq !== 'undefined'){
        _paq.push(['trackEvent', event, action]);
    }
}